/**
 * 予約候補日検索の候補を、確認用の予約表のページ（schedule.tsx）に渡すためのデータ
 * 一覧の画面から FullCalendar を読み込まずに使えるよう、ページとは別のファイルにしている
 */

// 候補の1人分（2日連続の場合は、その日の分）
export type ScheduleViewPerson = {
  label: string  // 「1人目（男性）」など。氏名は含めない
  reception?: string  // 受付日時（ISO）
  exams: { modalityID: string, body2: string, contrast: string, start: string, end: string, ivCheckin?: string }[]
}

export type ScheduleViewData = {
  title: string  // 「候補1：2026/12/14（月）1日目」など
  date: string  // YYYY-MM-DD
  persons: ScheduleViewPerson[]
}

// 候補の検査を開くための URL
export const scheduleViewUrl = (data: ScheduleViewData) => `/candidates/schedule?data=${encodeURIComponent(JSON.stringify(data))}`
